import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './addressPage.css'; // Make sure to import the CSS file
import Header from '../../components/common/header';
import Footer from '../../components/common/footer';
import '../home/homePage.css'
import { useUser } from '../../contexts/userContext';
import { useCart } from '../../contexts/cartContext';

const AddressPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { checkSessionTokenExpirationStatus, handleRemoveLocalStorage } =
      useUser();
      const { fetchCartQuantity,cartQuantity,setCartQuantity,handleQuantity } = useCart();
      const { setcityName, globalSearchTerm, setGlobalSearchTerm, setSessionCode, setUserId, setUsername, setUtmSessionId,fetchCsrfToken } = useUser();
    const user_id = location.state?.user_id;
    const cart_id = location.state?.cart_id;
    const session_code = location.state?.session_code;
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const version = process.env.REACT_APP_VERSION;
    //console.log(">>>>>>>---------addresspage",location.state)

    const [address, setAddress] = useState({
        address_id: '',
        customer_name: '',
        mobile_no: '',
        pincode: '',
        address_1: '',
        address_2: '',
        landmark: '',
        city: '',
        state_id: '',
        is_default: 0,
        user_id:user_id,
        cart_id:cart_id,
        sessionCode:session_code
    });
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!user_id) {
            // If user_id is missing, set an error and redirect to a different page or show an alert
            setError('User ID is missing.');
            navigate('/login'); // Redirect to the homepage or a specific page
            window.scrollTo({ top: 0, behavior: 'smooth' })
            return;
        }

        const fetchAddress = async () => {
            try {
                const response = await fetch(`${backendUrl}${version}Address/${user_id}/${session_code}`, 
                    {  method: 'GET',
                        headers:{
                          // Accept:'aplication/json',
                          "Content-Type": "application/json",
                  
                        },
                         credentials: "include",
                        mode:"cors"
                  
                      }
            );

                const data = await response.json();
                if (response.ok) {
                    if (data.data) {
                        setAddress({
                            ...address,
                            customer_name: data.data.name,
                            mobile_no: data.data.mobile_no,
                            address_id: data.data.address_id,
                            address_1: data.data.address_1,
                            address_2: data.data.address_2,
                            landmark: data.data.landmark,
                            city: data.data.city,
                            state_id: data.data.state_id,
                            pincode: data.data.pincode,
                            is_default: data.data.is_default ? 1 : 0,
                        });
                    } else {
                        setError('No address found for this user.');
                    }
                } else {
                    setError('Failed to fetch address.');
                }
            } catch (err: any) {
                setError('Error fetching address');
            }
        };

        fetchAddress();
    }, [user_id, navigate]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAddress({
            ...address,
            [e.target.name]: e.target.value
        });
    };

    const handleCartAddressUpdate = async ()=> {
        
        try {
            const csrfToken = await fetchCsrfToken();
            const response = await fetch(`${backendUrl}${version}update-cart-address`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken,
                    // 'Authorization': 'Bearer your_token', // Add your authorization token here
                },
                credentials: "include",
                body: JSON.stringify(address),
                
            });

            const data = await response.json();
            if (response.ok) {
                
            } else {
                setError(data.message || 'Failed to update address.');
            }
        } catch (err: any) {
            setError('Error updating address');
        }
    };

    const handleContinuePickup = () => {
        const returnUrl = window.location.pathname;
        handleCartAddressUpdate()
        // Navigate to the AddressPage, passing user_id and returnUrl
        navigate('/order-summary', { state: { user_id: user_id ,session_code:session_code} });
        window.scrollTo({ top: 0, behavior: 'smooth' })
    };
    
    useEffect(() => {
        const isSessionHandled = sessionStorage.getItem("sessionHandled");
      
        // If the session was already handled, avoid running this logic again
        if (isSessionHandled) return;
      
        // console.log("------>>>>>>>>>>>>>>>>>aboutus-------", checkSessionTokenExpirationStatus());
      
        if (checkSessionTokenExpirationStatus()) {
          // Clear session-related operations
          handleQuantity();
          handleRemoveLocalStorage();
      
          // Set the sessionHandled flag to true to prevent re-execution after reload
          sessionStorage.setItem("sessionHandled", "true");
      
          // Redirect to the homepage
          navigate("/");
      
          // Reload the page to clear cache
          window.location.reload();
        }
      }, []);

    return (
        <div>
            <Header />
            <main className="main-content-address-page">
                <div className="address-content">
                    <h1>My Pickup Address</h1>
                    <form className="address-form">
                        <div className="form-group">
                            <label htmlFor="user_name">Name:</label>
                            <input 
                                type="text" 
                                id="user_name" 
                                name="user_name" 
                                value={address.customer_name} 
                                onChange={handleChange} 
                                required 
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="mobile_no">Mobile No:</label>
                            <input 
                                type="text" 
                                id="mobile_no" 
                                name="mobile_no" 
                                value={address.mobile_no} 
                                onChange={handleChange} 
                                required 
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="pincode">Pincode:</label>
                            <input 
                                type="text" 
                                id="pincode" 
                                name="pincode" 
                                value={address.pincode} 
                                onChange={handleChange} 
                                required 
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="address_1">Address Line 1:</label>
                            <input 
                                type="text" 
                                id="address_1" 
                                name="address_1" 
                                value={address.address_1} 
                                onChange={handleChange} 
                                required 
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="address_2">Address Line 2:</label>
                            <input 
                                type="text" 
                                id="address_2" 
                                name="address_2" 
                                value={address.address_2} 
                                onChange={handleChange} 
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="landmark">Landmark:</label>
                            <input 
                                type="text" 
                                id="landmark" 
                                name="landmark" 
                                value={address.landmark} 
                                onChange={handleChange} 
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="city">City:</label>
                            <input 
                                type="text" 
                                id="city" 
                                name="city" 
                                value={address.city} 
                                onChange={handleChange} 
                                required 
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="state">State:</label>
                            <input 
                                type="text" 
                                id="state" 
                                name="state" 
                                value={address.state_id} 
                                onChange={handleChange} 
                                required 
                            />
                        </div>
                        <button onClick={handleContinuePickup}>continue</button>
                    </form>
                    {error && <p className="error">{error}</p>}
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default AddressPage;
